// Shared helpers for the board, race and results views.
import { toast } from './Toast';

// Category colors by difficulty level (0 yellow, 1 green, 2 blue, 3 purple).
export const CAT = ['var(--c1)', 'var(--c2)', 'var(--c3)', 'var(--c4)'];
const SHARE_SQUARES = ['\u{1F7E8}', '\u{1F7E9}', '\u{1F7E6}', '\u{1F7EA}'];

// Seconds -> m:ss
export const fmtTime = (seconds) => {
  if (typeof seconds !== 'number' || !Number.isFinite(seconds)) return '-';
  const t = Math.max(0, Math.floor(seconds));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
};

export const initial = (name) => (String(name || '?').trim()[0] || '?').toUpperCase();

// Stable color for a name (used where there is no seat order, e.g. the daily leaderboard).
export const colorFor = (name) => {
  let h = 0;
  for (const ch of String(name || '')) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return CAT[h % 4];
};

export function Avatar({ name, color }) {
  return <span className="cr-av" style={{ background: color }} aria-hidden="true">{initial(name)}</span>;
}

export function Dots({ left, small = false }) {
  return (
    <span className={`cr-dots${small ? ' sm' : ''}`} role="img" aria-label={`${left} mistakes remaining`}>
      {[0, 1, 2, 3].map((i) => <i key={i} className={i < left ? '' : 'used'} />)}
    </span>
  );
}

// Four cells, filled in the order groups were found, each in its category color.
export function Progress({ levels = [] }) {
  return (
    <span className="cr-prog" role="img" aria-label={`${levels.length} of 4 groups found`}>
      {[0, 1, 2, 3].map((i) => (
        <i key={i} style={levels[i] != null ? { background: CAT[levels[i]] } : undefined} />
      ))}
    </span>
  );
}

export const buildShareText = ({ title, subtitle, solved, time, history }) => [
  title,
  subtitle,
  solved ? `Solved in ${fmtTime(time)}` : 'Out of lives',
  ...history.map((row) => row.map((lvl) => (lvl == null ? '\u2B1C' : SHARE_SQUARES[lvl])).join('')),
  'Play at connectionsracer.com',
].filter(Boolean).join('\n');

export async function copyText(text, okMessage) {
  try {
    await navigator.clipboard.writeText(text);
    toast(okMessage);
  } catch (_) {
    toast('Copy failed', { error: true });
  }
}
